"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({}).passthrough();
const dataSchema = zod_1.z.object({}).passthrough();
exports.default = new ItemDefinition_1.ItemDefinition("Custom", configSchema, dataSchema, new validation_1.ValidatorPipeline("Custom Config Validator", [
    (0, validation_1.createZodSchemaValidator)(["customScript"], zod_1.z.string((0, validation_1.labelZodErrors)("Script")).min(6)),
]), new validation_1.ValidatorPipeline("Custom Data Validator", []));
//# sourceMappingURL=Custom.js.map